var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 198.6 121" }, props),
    React.createElement("path", { d: "M71 56.7c-10.5 0-19.2 8.2-19.5 18.3-.3 9.9 6.9 17.5 16.8 17.5 10.8 0 18.4-7.7 18.7-18.6.4-10-6.5-17.2-16-17.2z" }),
    React.createElement("path", { d: "M177.2 0H40.1c-9.9 0-18.5 6.8-20.8 16.4L.6 94.7c-.4 1.6-.6 3.3-.6 5C0 111.5 9.6 121 21.4 121h137c9.9 0 18.5-6.8 20.8-16.4L198 26.3c.4-1.6.6-3.3.6-5C198.6 9.5 189 0 177.2 0zM97.1 72.3c-.7 17-12.7 29-29.7 29-10.5 0-26.9-5.5-25.8-34 .9-25.4 15.4-47 36.6-47 13.5 0 23.5 8.9 24.5 21.9h-10C91.4 34.1 85.5 29 77.2 29c-11.7 0-21.5 11.7-25 29.8l.3.1c4.8-6.7 12.6-10.6 20.8-10.5 14.3-.1 24.2 9.8 23.8 23.9zM154 99.9h-51.4l16.7-78.5h16.5l-13.7 64.2h34.8L154 99.9z" })
  );
});


// WEBPACK FOOTER //
// ./src/static/images/six_lead_badge.svg